export default class AnalyticsManager {
    constructor() {

    }

    /**
     * 
     * @param {String} name Name of the variable to set
     * @param {any} value Value to set
     */
    static setVariable(name, value) {
        let json = {[name]: value.toString()};
        AnalyticsManager.pushToDataLayer(json);
    }
    /**
     * 
     * @param {String} eventName Name of event to dispatch to DataLayer
     */
    static dispatchEvent(eventName) {
        AnalyticsManager.pushToDataLayer({'event' : eventName})
    }

    static isDisabled() {
        return typeof window === 'undefined' || !Array.isArray(window.dataLayer);
    }

    static warn(message, error) {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn(message, error);
        }
    }

    static pushToDataLayer(payload) {
        if (AnalyticsManager.isDisabled()) {
            return false;
        }

        try {
            window.dataLayer.push(payload);
            return true;
        } catch (error) {
            AnalyticsManager.warn('[AnalyticsManager] Unable to push analytics event.', error);
            return false;
        }
    }

    static getSessionStorage() {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return null;
        }

        return window.sessionStorage;
    }
    /**
     * Initializes Analytics manager, setting base variables and settings needed on each page
     */
    static initialize() {
        if(AnalyticsManager.isDisabled()) return;
        let store_id = window.session && window.session.store ? window.session.store.id : null;
        if (store_id !== null && typeof store_id !== 'undefined') {
            AnalyticsManager.setVariable('store_id', store_id);
        }
    }
    /**
     * 
     * @param {Array} itemsOnPage Array of itemNavs on page
     * @param {String} category Name of category
     * @param {Boolean} isHome Set to true if on welcome screen
     */
    static registerItemImpressions(itemsOnPage, category, isHome) {
        if(AnalyticsManager.isDisabled()) return;
        let itemsImpressed = itemsOnPage.map( (val, ind, arr) => {
            if(val) {
                return {
                'name': val.name,       // Name or ID is required.
                'id': val.id,
                'brand': AnalyticsManager.getBrand(),
                'category': category,
                'list': isHome ? 'Homepage' : 'Menu Page',
                'position': ind + 1
                };
            }
        });
        let impression = {
            'ecommerce': {
                'impressions': itemsImpressed
            }
        };
        AnalyticsManager.pushToDataLayer(impression);
    }

    /**
     * 
     * @param {Object} item Item provided from Item Tile
     * @param {String} url URL to redirect to after push
     * @param {String} category Name of category
     */
    static registerProductClick(item, url, category) {
        if(AnalyticsManager.isDisabled()) {
            document.location = url;
            return;
        }
        let callback = function() {document.location = url};
        let itemClick = {
            'event': 'productClick',
            'ecommerce': {
                'click': {
                  'actionField': {},      // Optional list property.
                  'products': [{
                    'name': item.name,                      // Name or ID is required.
                    'id': item.id,
                    'brand': AnalyticsManager.getBrand(),
                    'category': category,
                    'position': item.position + 1
                   }]
                 }
               },
            'eventCallback': callback
        };
        AnalyticsManager.pushToDataLayer(itemClick);
        callback();
    }

    //Included Add-Ons and modifiers
    //TODO TODO TODO
    static registerItemDetailView(itemNavigation) {
        if(AnalyticsManager.isDisabled()) return;
        let products = { // Map over addons and base item and compile them
            /**
             * 'products': [{
                  'name': 'Triblend Android T-Shirt',         // Name or ID is required.
                  'id': '12345',
                  'price': '15.25',
                  'brand': 'Google',
                  'category': 'Apparel',
                  'variant': 'Gray'
                 }]
             */
        };
        let detailView = {
            'ecommerce': {
                'detail' : {
                    'actionField' : {'list': "TODO"},
                    'products' : products
                }
            }
        };
        AnalyticsManager.pushToDataLayer(detailView);
    }

    /**
     * 
     * @param {Object} item Representation of the chosen items
     * @param {String} item.name Name of item
     * @param {Number} item.id ID of item
     * @param {Number} item.price Calculated Subtotal of item
     * @param {String} item.variant Name of Main Item Chosen
     * @param {Number} item.quantity Quantity
     * @param {Array} [addons] Array of addons (optional)
     */
    static addItemToCart(item, addons) {
        if(AnalyticsManager.isDisabled() || !item || typeof item !== 'object') return;
        let products = [
            {
                'name': item.name,
                'id': item.id,
                'price': item.price,
                'brand': AnalyticsManager.getBrand(),
                'category': item.category,
                'variant': item.variant, //Chosen main item,
                'quantity': item.quantity
            }
        ];
        if(Array.isArray(addons) && addons.length > 0) {
            addons.forEach(addon => {
                if(!addon || typeof addon !== 'object') {
                    return;
                }

                products.push({
                    'name': addon.name,
                    'id': addon.id,
                    'price': addon.price,
                    'brand': AnalyticsManager.getBrand(),
                    'category': `${item.category} - addon`, //TODO: Find way to set this from items page
                    'quantity': addon.quantity
                })
            });
        }
        AnalyticsManager.pushToDataLayer({
            'event': 'addToCart',
            'ecommerce': {
              'add': {                                // 'add' actionFieldObject measures.
                'products': products
              }
            }
          });
    }
    /**
     * 
     * @param {Object} item LineItem to remove
     * @param {String} item.name Name of item to be removed
     * @param {Number} item.id ID of item to be removed
     * @param {Number} item.subtotal Subtotal of item to be removed
     * @param {Number} item.quantity Qty of item to be removed
     */
    static removeItemFromCart(item) {
        if(AnalyticsManager.isDisabled() || !item || typeof item !== 'object') return;
        let itemsToBeRemoved = [
            {                          //  removing a product to a shopping cart.
                'name': item.friendly_name || item.name,
                'id': item.item_navigation_id || item.item_id || item.id,
                'price': typeof item.subtotal !== 'undefined' ? item.subtotal : item.total,
                'brand': AnalyticsManager.getBrand(),
                'quantity': item.quantity
            }
        ];
        let cartRemoval = {
            'event': 'removeFromCart',
            'ecommerce' : {
                'remove' : {
                    'products': itemsToBeRemoved
                }
            }
        }
        AnalyticsManager.pushToDataLayer(cartRemoval);
    }

    static convertLineItemsToProducts(lineItems) {
        if(AnalyticsManager.isDisabled()) return [];
        let products = [];
        if(Array.isArray(lineItems) && lineItems.length > 0) {
            lineItems.forEach( (val, ind, arr) => {
                if(!val || typeof val !== 'object') {
                    return;
                }

                let choices = AnalyticsManager.parseChoices(val.choices);
                if(choices) {
                    //Only register main items
                    let variantString = '';
                    let modifications = Array.isArray(val.modifications) ? val.modifications : [];
                    modifications.forEach( (modVal, modInd, modArr) => {
                        if(!modVal || !modVal.name) {
                            return;
                        }
                        if(variantString.length > 0) {
                            //skip on first run
                            variantString = variantString + ' – ';
                        }
                        variantString = variantString + modVal.name;
                    });
                    products.push({                    
                        'name': val.friendly_name || val.name,
                        'id': val.item_navigation_id || val.item_id || val.id,
                        'price': typeof val.subtotal !== 'undefined' ? val.subtotal : val.total,
                        'brand': AnalyticsManager.getBrand(),
                        'quantity': val.quantity,
                        'category': choices.category || val.category_id,
                        'variant': variantString
                    });
                }
            });
        }
        return products;
    }

    static parseChoices(choices) {
        if (!choices) {
            return {};
        }

        if (typeof choices === 'object') {
            return choices;
        }

        if (typeof choices !== 'string') {
            return {};
        }

        try {
            return JSON.parse(choices);
        } catch (error) {
            return {};
        }
    }

    static getBrand() {
        if (typeof window === 'undefined') {
            return ' -- ';
        }

        let chainName = window.session && window.session.chain ? window.session.chain.name : '';
        let storeName = window.session && window.session.store ? window.session.store.name : '';
        return `${chainName} -- ${storeName}`;
    }

    static reviewCart(lineItems, option, callback) {
        try {
            if(!AnalyticsManager.isDisabled()) {
                let products = AnalyticsManager.convertLineItemsToProducts(lineItems);
                let data = {
                    'event': 'checkout',
                    'ecommerce': {
                        'checkout': {
                            'actionField': {'step': 1, 'option': option},
                            'products': products
                        }
                    },
                    'eventCallback': callback
                };
                AnalyticsManager.pushToDataLayer(data);
            }
        } catch (error) {
            AnalyticsManager.warn('[AnalyticsManager] Unable to track cart review.', error);
        } finally {
            callback();
        }
    }

    static updateServiceType(serviceType) {
        if(AnalyticsManager.isDisabled()) return;
        AnalyticsManager.pushToDataLayer({
            'event': 'checkoutOption',
            'ecommerce': {
              'checkout_option': {
                'actionField': {'step': 1, 'option': serviceType}
              }
            }
          });
    }

    static updateUserType(userType) {
        if(AnalyticsManager.isDisabled()) return;
        AnalyticsManager.pushToDataLayer({
            'event': 'checkoutOption',
            'ecommerce': {
              'checkout_option': {
                'actionField': {'step': 2, 'option': userType}
              }
            }
          });
    }

    static updatePaymentType(pmtType) {
        if(AnalyticsManager.isDisabled()) return;
        AnalyticsManager.pushToDataLayer({
            'event': 'checkoutOption',
            'ecommerce': {
              'checkout_option': {
                'actionField': {'step': 3, 'option': pmtType}
              }
            }
          });
    }

    static userConfirmation(lineItems, option, callback) {
        if(AnalyticsManager.isDisabled()) {
            callback();
            return;
        }
        let products = AnalyticsManager.convertLineItemsToProducts(lineItems);
        let data = {
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2, 'option': option},
                    'products': products
                }
            },
            'eventCallback': callback
        };
        AnalyticsManager.pushToDataLayer(data);
        callback();
    }

    static paymentInfo(lineItems, option, callback) {
        if(AnalyticsManager.isDisabled()) {
            callback();
            return;
        }
        let products = AnalyticsManager.convertLineItemsToProducts(lineItems);
        let data = {
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 3, 'option': option},
                    'products': products
                }
            },
            'eventCallback': callback
        };
        AnalyticsManager.pushToDataLayer(data);
        callback();
    }

    static setPurchase(lineItems, transactionID, subtotal, tax, delivery, couponCode, userID) {
        if(AnalyticsManager.isDisabled()) return;
        // let callback = function() {
        //     let url = window.relativeURI() + '/my-order/' + userID;
        //     document.location = url;
        // }
        // if(AnalyticsManager.isDisabled()) {
        //     callback();
        //     return;
        // }
        let products = AnalyticsManager.convertLineItemsToProducts(lineItems);
        let data = {
            'ecommerce': {
                'purchase': {
                  'actionField': {
                    'id': transactionID,                         // Transaction ID. Required for purchases and refunds.
                    'affiliation': AnalyticsManager.getBrand(),
                    'revenue': subtotal,                     // Total transaction value (incl. tax and shipping)
                    'tax': tax,
                    'shipping': delivery,
                    'coupon': couponCode
                  },
                  'products': products
                }
            }
        };
        // Supply GA4 revenue fields alongside the legacy purchase payload.
        const purchaseValue = typeof subtotal === 'number'
            ? subtotal
            : typeof subtotal === 'string' && subtotal.trim() !== ''
                ? Number(subtotal)
                : NaN;
        if (Number.isFinite(purchaseValue)) {
            data.ecommerce.value = purchaseValue;
            data.ecommerce.currency = 'USD';
        } else {
            AnalyticsManager.warn('[AnalyticsManager] Invalid purchase value; GA4 revenue fields were omitted.');
        }
        try {
            let dataJson = JSON.stringify(data);
            let storage = AnalyticsManager.getSessionStorage();
            if (storage) {
                storage.setItem('ga_purchase', dataJson);
            }
            // callback();
            AnalyticsManager.postPurchase();
        } catch (error) {
            AnalyticsManager.warn('[AnalyticsManager] Unable to store purchase analytics.', error);
        }
    }

    static postPurchase() {
        if(AnalyticsManager.isDisabled()) {
            return;
        }

        try {
            let storage = AnalyticsManager.getSessionStorage();
            if (!storage) {
                return;
            }

            let purchase = storage.getItem('ga_purchase');
            if(purchase) {
                let data = JSON.parse(purchase);
                AnalyticsManager.pushToDataLayer(data);
                AnalyticsManager.dispatchEvent('order_view');
                storage.removeItem('ga_purchase');
            }
        } catch (error) {
            AnalyticsManager.warn('[AnalyticsManager] Unable to post purchase analytics.', error);
        }
    }
}
